module.exports = __webpack_public_path__ + "img/Cultural_two_bottom.3155c143.gif";